/**
 * Newton showcase: swaps the Whitelabels.com marks for Newton's logo.
 *
 * Two switches turn it on. A signed-in owner's `n_showcase: true` user preference
 * (read through `selectNShowcase` in `store/slices/userPreferences`), and this
 * browser-local one, `localStorage.n_showcase = 'true'`, which also works signed
 * out: the boot loader (`/`, `index.html` + `PageLoader`), the auth screens
 * (`/login`, `/register`) and the configurator read it. Set it from the console
 * with `localStorage.setItem('n_showcase', 'true')` and reload.
 */
export const N_SHOWCASE_STORAGE_KEY = 'n_showcase';

/** Newton's full logo (newton.ro/img/logo_newton_large_full.png): metallic N + white
 *  wordmark, for dark surfaces. */
export const NEWTON_LOGO_SRC = '/assets/newton/n-logo.png';

/** The same logo with the wordmark in dark ink (#1A1A1A), for light surfaces. */
export const NEWTON_LOGO_LIGHT_SRC = '/assets/newton/n-logo-light.png';

/** The Newton N alone, cut from the full logo. */
export const NEWTON_MARK_SRC = '/assets/newton/newton-n.png';

/** Whether the browser-local showcase switch is on. False when storage is blocked. */
export const isNShowcaseLocal = (): boolean => {
  try {
    return window.localStorage.getItem(N_SHOWCASE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};
